module.exports = __webpack_public_path__ + "static/media/7.d6202c27.jpg";